import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { MarkantElementsModule } from '@markant/elements-angular';
import { AdditionalOrgDataForm, UpgradeServiceVariantForm } from '../upgrade-forms.config';
import { AdditionalOrganizationDataFormComponent } from '../complete-org-data/additional-org-data-form/additional-org-data-form.component';
import { UpgradeServiceVariantsComponent } from '../upgrade-service-variants/upgrade-service-variants.component';
import { BookingDataWithUpgradeInfo, CartridgeVariant } from '@markant-platform/cartridge/model';
import { OrganizationDetailData } from 'data-model';

@Component({
  selector: 'markant-platform-variant-upgrade-overview',
  templateUrl: './variant-upgrade-overview.component.html',
  styleUrls: ['./variant-upgrade-overview.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MarkantElementsModule,
    UpgradeServiceVariantsComponent,
    AdditionalOrganizationDataFormComponent,
  ],
})
export class VariantUpgradeOverviewComponent implements OnInit {
  variantUpgradeForm = input.required<UpgradeServiceVariantForm>();
  additionalOrgDataForm = input.required<AdditionalOrgDataForm>();
  upgradeCandidates = input.required<CartridgeVariant[]>();
  booking = input.required<BookingDataWithUpgradeInfo>();
  organization = input.required<OrganizationDetailData>();
  selectedVariant!: CartridgeVariant;

  ngOnInit(): void {
    this.selectedVariant = this.upgradeCandidates().find(
      variant => variant.variantId === this.variantUpgradeForm().controls.variant.value
    ) as CartridgeVariant;
  }
}
